/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  // Refresh an already controlled page when a new app bundle becomes active.
  // Initial installation should not interrupt the first visit.
  const wasControlled = Boolean(navigator.serviceWorker?.controller)
  let refreshing = false
  navigator.serviceWorker?.addEventListener('controllerchange', () => {
    if (wasControlled && !refreshing) {
      refreshing = true
      window.location.reload()
    }
  })
  register(`${process.env.BASE_URL}service-worker.js`, {
    updated (registration) {
      registration.waiting?.postMessage({ type: 'SKIP_WAITING' })
    },

    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
